import {
  hideRecordingListOutOfSyncBanner,
  nextRecording,
  pause,
  play,
  previousRecording,
  readOnly,
  updateWorthWatchingAnswer,
} from '@hotjar/recordings/src/features/Playbacks/utils';
import { OPENER } from '@hotjar/recordings/src/features/Playbacks/constants/opener';
import { useStoreState, useStore, useSelector } from '@hotjar/recordings/src/store/player/context';
import { AutogeneratedRecordingBanner } from '../../../Activation/AutogeneratedRecordingBanner';
import { DismissibleBanner, TopMenu } from '../..';

export const TopSection = (): JSX.Element => {
  const playerStore = useStore();
  const { setShared, openWorthWatchingTooltip } = useStoreState();
  const {
    playing,
    recording,
    isShared,
    isSharedRecording,
    isWorthWatching,
    playlistVisible,
    siteId,
    loaded,
    isLightPlayer,
    isAutogenerated,
    isRecordingListOutOfSync,
    playbacksOpener,
  } = useSelector((state) => ({
    playing: state.playing,
    user: state.user,
    recording: state.recording,
    isShared: state.isShared,
    isSharedRecording: state.isSharedRecording,
    isWorthWatching: state.isWorthWatching,
    playlistVisible: state.playlistVisible,
    siteId: state.siteId,
    loaded: state.loaded,
    isLightPlayer: state.isLightPlayer,
    isAutogenerated: state.isAutogenerated,
    isRecordingListOutOfSync: state.isRecordingListOutOfSync,
    playbacksOpener: state.playbacksOpener,
  }));

  return (
    <header id="playback-top-menu-wrapper" className="top-section">
      <TopMenu
        onShare={setShared}
        isPlaying={playing}
        play={(showAnimation?: boolean) => play(playerStore, showAnimation)}
        pause={(showAnimation: boolean, manualPause: boolean) =>
          pause(playerStore, showAnimation, manualPause)
        }
        recording={recording}
        isShared={isShared}
        isReadOnly={readOnly(playerStore)}
        isTokenShared={isSharedRecording}
        playlistVisible={playlistVisible}
        onWorthWatchingAnswerChange={(answer: boolean | null) =>
          updateWorthWatchingAnswer(playerStore, answer)
        }
        worthWatchingAnswer={isWorthWatching}
        openWorthWatchingTooltip={openWorthWatchingTooltip}
        siteId={siteId}
        loaded={loaded}
        hideControls={isLightPlayer}
        hideBackButton={playbacksOpener === OPENER.FUNNELS}
        onPrevious={() => previousRecording(playerStore)}
        onNext={() => nextRecording(playerStore)}
      />

      {isAutogenerated ? <AutogeneratedRecordingBanner /> : null}

      <DismissibleBanner
        kind="danger"
        showBanner={isRecordingListOutOfSync}
        className="top-banner"
        message="Your recordings list seems to be out of sync with our server. Please return to your list."
        onDismiss={() => hideRecordingListOutOfSyncBanner(playerStore)}
      />
    </header>
  );
};
